export const dataExplorer = {
  confirm: "Bestätigen",
  cancel: "Abbrechen",
  dataExplorer: "Data-Explorer",
  dataExplorerResources: "Data-Explorer - Ressourcen",
  dataStructures: "Datenstrukturen",
  dataSets: "Data-Sets",
  dataStructure: "Datenstruktur",
  dataSet: "Data-Set",
  noDescription: "Keine Beschreibung vorhanden",
  details: "Details",
  preview: "Vorschau",
  schema: "Schema",
  entriesCount: "Datensätze",
  dirtyEntriesCount: "Unverarbeitete Datensätze",
  lastUpdated: "Letzte Änderung",
  dataLastUpdated: "Letzte Datenänderung",
  editDataSet: "Data-Set bearbeiten",
  editDataStructure: "Datenstruktur bearbeiten",
  truncateDataStructure: "Datenstruktur leeren",
  importData: "Daten aus JSON importieren",
  importDataSuccess: "Datensätzen wurden erfolgreich importiert",
  importDataError: "Datensätzen wurden nicht erfolgreich importiert",
  setCleanDataStructure: "Alle Einträge auf verarbeitet setzen",
  setDirtyDataStructure: "Alle Einträge auf unverarbeitet setzen",
  setCleanDataStructureEntry: "Einträg auf verarbeitet setzen",
  setDirtyDataStructureEntry: "Einträg auf unverarbeitet setzen",
  truncateText:
    'Möchten Sie die Datenstruktur "{name}" wirklich leeren? Dieser Vorgang ist unwiderruflich.',
  truncateTitle: "Datenstruktur leeren",
  setCleanText:
    'Möchten Sie wirklich alle Datensätze der Datenstruktur "{name}" auf verarbeitet setzen? Dieser Vorgang ist unwiderruflich.',
  setCleanSuccess: "Einträge auf verarbeitet gesetzt",
  setCleanTitle: "Datenstruktur bearbeiten",
  setDirtyText:
    'Möchten Sie wirklich alle Datensätze der Datenstruktur "{name}" auf unverarbeitet setzen? Dieser Vorgang ist unwiderruflich.',
  setDirtySuccess: "Einträge auf unverarbeitet gesetzt",
  setDirtyTitle: "Datenstruktur bearbeiten",
  filter: "Filter",
  dirty: "Unverarbeitet",
  clean: "Verarbeitet",
  noFilter: "Filter entfernen",
  openDetails: "Daten einsehen",
  deletedSuccess: "Alle Einträge wurde erfolgreich gelöscht",
  dataStructureFromRequest: "Datenstruktur (Request)",
  massDeleteSuccess: "Die ausgewählten Einträge wurden erfolgreich gelöscht."
};
